// src/data/quotesUtil.js
export function getQuotesByMonthDay(quotes) {
  const quotesByDate = {};
  quotes.forEach((q) => {
    if (!q.englishdate) return;
    let parts = q.englishdate.split("-");
    let mm, dd;
    if (parts.length === 3) {
      mm = parts[1].padStart(2, "0");
      dd = parts[2].padStart(2, "0");
    } else if (parts.length === 2) {
      mm = parts[0].padStart(2, "0");
      dd = parts[1].padStart(2, "0");
    } else {
      return;
    }
    const key = `${mm}-${dd}`;
    if (!quotesByDate[key]) quotesByDate[key] = [];
    quotesByDate[key].push(q);
  });
  return quotesByDate;
}
